export const QUERY_PARAM_ROUTES = Object.freeze({
  RESERVATION_LIST: '/reservations',
  SEARCH: '/search',
});
